import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import MerchantShop from "../icon/MerchantShop";
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from "react-i18next";
import { useNewVenueDialog } from "../../hooks/useNewVenueDialog";


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: "flex",
            width: "100%",
            height: "3.5rem",
            padding: '0.25rem 1rem 0.25rem 1rem',
            margin: '0.25rem',
            marginTop: '1rem',
            cursor: "pointer",
            color: theme.palette.text.secondary,
            textAlign: 'start',
            fontWeight: 600
        },
        merchantShop: {
            width: '12.5%',
            background: theme.palette.background.default,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: "8px",
            display: 'flex',
            padding: '0.1rem'
        },
        title: {
            width: '70%',
            marginTop: '0.65rem',
            marginLeft: '1rem',
            color: theme.palette.text.secondary
        },
        endIcon: {
            marginTop: '0.65rem',
            width: "10%",
            "& svg": {
                float: 'right',
                marginTop: '0.1rem',

            }
        }
    }))


export function CreateVenueButton(history:any) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { onNewVenue } = useNewVenueDialog(history);

    return <div onClick={onNewVenue} className={classes.root}>
        <div className={classes.merchantShop}>
            <MerchantShop />
        </div>
        <div className={classes.title}>
            {t('signup.newVenue.addANewVenue')}
        </div>
        <div className={classes.endIcon}>
            <AddIcon />
        </div>
    </div>

}